var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"a",attrs:{"d":"M15,0H5A2.08,2.08,0,0,0,3,2V4H5V2H15V16H5V14H3v4a2.08,2.08,0,0,0,2,2H15a2.08,2.08,0,0,0,2-2V2A2.08,2.08,0,0,0,15,0ZM11,18a1,1,0,1,1-1-1A1,1,0,0,1,11,18ZM8,7.06,7,6,3.14,9.88,1,7.76,0,8.82,3.14,12Z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }